<template>
  <!-- 对话框 -->
  <el-drawer title="添加司机信息" :visible.sync="show" :with-header="false" :before-close="closeDialog" size="600px">

    <!-- 基本信息表单 -->
    <div class="form-box">



      <template>

        <el-form ref="form" :model="submit_data" label-width="80px" style="height: 90vh; overflow-y: auto;">



          <el-form-item label="段位等级:" label-width='120px'>

            <el-select v-model="submit_data.level_set" :placeholder="submit_rules.level_set.placeholder"
              style="width: 150px; margin-right: 20px;" clearable>
              <el-option :label="item.alias" :value="index" v-for="(item, index) in level_select" :key="index">
              </el-option>
            </el-select>

          </el-form-item>


          <el-form-item label="星级分:" label-width='120px'>
            <el-input v-model="submit_data.star_point_set" :placeholder="submit_rules.star_point_set.placeholder"
              style="width: 80%;">
            </el-input>
          </el-form-item>

          <el-form-item label="表现分:" label-width='120px'>
            <el-input v-model="submit_data.monitor_point_set" :placeholder="submit_rules.monitor_point_set.placeholder"
              style="width: 80%;">
            </el-input>
          </el-form-item>

          <el-form-item label="销单率:" label-width='120px'>
            <el-input v-model="submit_data.cancel_order_set" :placeholder="submit_rules.cancel_order_set.placeholder"
              style="width: 80%;">
            </el-input>%
          </el-form-item>

          <el-form-item label="到期天数设置:" label-width='120px'>
            <el-input v-model="submit_data.signing_end_time_day_set"
              :placeholder="submit_rules.signing_end_time_day_set.placeholder" style="width: 80%;">
            </el-input>
          </el-form-item>

          <el-form-item label="司机等级:" label-width='120px'>
            <el-input v-model="submit_data.driver_level_set" :placeholder="submit_rules.driver_level_set.placeholder"
              style="width: 80%;">
            </el-input>
          </el-form-item>


          <el-form-item label="职位:" label-width='120px'>
            <el-select v-model="submit_data.capacity_set" style="width: 150px; margin-right: 20px;" clearable>
              <el-option label="全职司机" value="full_time">
              </el-option>
            </el-select>
          </el-form-item>




        </el-form>



        <!-- 对话框底部按钮 -->
        <div style="display: flex;justify-content: center">
<!--          <el-button type="primary" @click="onSubmit">保存</el-button>-->
          <submitBtn @onSubmitDig="onSubmitDig" :data="submit_data" :rules="submit_rules" :url="submit_url" :JSON_Boolean="false"></submitBtn>
          <el-button @click="closeDialog">关闭</el-button>
        </div>

      </template>



    </div>




  </el-drawer>
</template>

<script>
  var _this;
  export default {
    props: {
      'isShow': Boolean,
    },
    watch: {

      isShow(newData, oldData) {

        _this.show = true;

        _this.$post(
          "/driver/getDanLists",
          _this.city_options_data
        ).then(res => {

          _this.level_select = res.data

        }).catch((err) => {

        })


      },
    },
    data() {
      return {


        show: false,


        level_select: [],

        submit_url:'/driver/addDriverDanSetSubmit',
        // 表单数据
        submit_data: {
          level_set: '',
          star_point_set: '',
          monitor_point_set: '',
          cancel_order_set: '',
          signing_end_time_day_set: '',
          driver_level_set: '',
          capacity_set: ''
        },

        submit_rules: {
          level_set: {
            placeholder: '段位等级',
            rules: {
              required: true,
              message: '段位等级不能大于3',
              regulation: 'elt',
              rulesData: 3
            }
          },
          star_point_set: {
            placeholder: '星级分',
            rules: {
              required: false,
              message: '星级分不能大于5',
              regulation: 'elt',
              rulesData: 5
            }
          },
          monitor_point_set: {
            placeholder: '表现分',
            rules: {
              required: false,
              message: '表现分不能大于5',
              regulation: 'gt_str',
              rulesData: 0
            }
          },
          cancel_order_set: {
            placeholder: '销单率',
            rules: {
              required: false,
              message: '销单率错误',
              regulation: 'gt_str',
              rulesData: 0
            }
          },
          monitor_point_set: {
            placeholder: '表现分',
            rules: {
              required: false,
              message: '表现分错误',
              regulation: 'gt_str',
              rulesData: 0
            }
          },
          signing_end_time_day_set: {
            placeholder: '到期天数',
            rules: {
              required: false,
              message: '到期天数错误',
              regulation: 'gt_str',
              rulesData: 0
            }
          },
          driver_level_set: {
            placeholder: '司机等级',
            rules: {
              required: false,
              message: '司机等级错误',
              regulation: 'gt_str',
              rulesData: 0
            }
          },
          capacity_set: {
            placeholder: '司机职位',
            rules: {
              required: false,
              message: '司机职位错误',
              regulation: 'gt_str',
              rulesData: 0
            }
          },
        },

      };
    },
    created() {

      _this = this;

    },
    methods: {





      // 关闭方法
      closeDialog() {
        _this.show = false;

        _this.submit_data = {
          level_set: '',
          star_point_set: '',
          cancel_order_set: '',
          signing_end_time_day_set: '',
          driver_level_set: '',
          capacity_set: ''
        };

        _this.value_city_code = '';
      },
      // 提交
      onSubmitDig() {


            // 触发父组件自定义事件刷新表格
            _this.$emit('onSubmit');
            _this.closeDialog();


      },


    }
  };
</script>

<style scoped>
  .form-box {
    padding: 20px;
    box-sizing: border-box;
    margin-right: 0;
    width: 100%;
  }

  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }

  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }

  .el-form-second {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
  }

  .avatar-uploader {
    width: 100px;
    height: 100px;
  }
</style>